import { memo } from "react";

import { Button } from "@bigbinary/neeto-atoms";
import { withT } from "neetocommons/react-utils";

import { FULL_SHORTCUTS_LINK_PROP_NAME } from "./constants";
import HotKey from "./HotKey";

const HotKeyList = withT(({ t, hotkeys }) =>
  Object.keys(hotkeys).map(categoryName => {
    const categoryValues = hotkeys[categoryName];
    const fullShortcutsLink = categoryValues[FULL_SHORTCUTS_LINK_PROP_NAME];

    return (
      <div className="mt-4 px-4" key={categoryName}>
        <span className="text-foreground text-xs font-bold uppercase">
          {categoryName}
        </span>
        {Object.entries(categoryValues).map(
          ([, { sequence, description }]) =>
            sequence && <HotKey {...{ description, sequence }} key={sequence} />
        )}
        {fullShortcutsLink && (
          <Button asChild className="mb-3" variant="link">
            <a href={fullShortcutsLink} rel="noreferrer" target="_blank">
              {t("neetoMolecules.keyboardShortcuts.viewFullListOfShortcuts")}
            </a>
          </Button>
        )}
      </div>
    );
  })
);

export default memo(HotKeyList);
